var _defs, _g, _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOvi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_33",
    "data-name": "R\\xE9teg 33",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #7ccfd2;\n        stroke-width: 20.92px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #e71b6d;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 34.77px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "472.42 427.53 472.42 471.18 464.37 471.18 464.37 444.48 452.97 463.18 447.87 463.18 435.92 444.23 435.92 471.18 427.97 471.18 427.97 427.53 434.42 427.53 450.32 452.58 465.87 427.63 472.42 427.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.47,427.53v25.85c0,10-8.55,17.71-18.2,17.71s-18.3-7.66-18.3-17.71v-25.85h8v25.85c0,5.8,4.6,10.5,10.3,10.5s10.2-4.8,10.2-10.5v-25.85h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.02,458.33c0,1.6-.45,3.35-1.1,4.75-2.2,5.15-6.95,8.01-12.4,8.01h-22.35v-43.56h20.55c5.45,0,9.9,2.75,12.1,7.75.7,1.55,1.2,3.3,1.2,5.05,0,3.1-1.15,5.55-3.2,7.75,3.25,2.55,5.2,5.9,5.2,10.25ZM369.97,458.33c0-3.1-2.45-5.85-5.45-5.85h-14.35v11.4h14.35c2.95,0,5.45-2.5,5.45-5.55ZM368.02,440.33c0-3-2.35-5.65-5.3-5.65h-12.55v10.65h12.55c2.75,0,5.3-1.95,5.3-5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.62 463.78 336.62 470.99 306.87 470.99 306.87 427.53 314.87 427.53 314.87 463.78 336.62 463.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,427.53l19.6,43.65h-8.7l-4.9-11.15h-18.2l-5.3,11.15h-8.7l20.85-43.65h5.35ZM283.42,452.78l-5.6-12.7-6.05,12.7h11.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.77,
    y: 427.43,
    width: 8,
    height: 43.61
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.07 427.53 194.67 471.13 188.87 471.13 169.87 427.53 178.52 427.53 191.87 458.13 206.32 427.53 215.07 427.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87,449.38c0,12.25-10.4,21.75-22.15,21.75s-22.1-9.5-22.1-21.75,10.35-21.75,22.1-21.75,22.15,9.55,22.15,21.75ZM158.87,449.38c0-7.9-6.4-14.65-14.15-14.65s-14.15,6.75-14.15,14.65,6.45,14.55,14.15,14.55,14.15-6.6,14.15-14.55Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 410.16,
    cy: 149.71,
    r: 27.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.61,162.08v160.59c0,32.51,34.87,58.87,77.89,58.87h158.26c43.02,0,77.89-26.36,77.89-58.87v-95.44"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 297.64,
    cy: 248.94,
    r: 65.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOvi);
export default __webpack_public_path__ + "static/media/logo_ovi.c9450de25b0ab941e7c202b76899dc5a.svg";
export { ForwardRef as ReactComponent };